import React from 'react';
import { Icon } from './Icon.js';
export const IconChartPyramid = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M3.5 15.01L20.5 15.01", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M6.98999 9.01001L17 9", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M13.3201 3H10.6801L1.5 18.5L2.5 21H21.5L22.5 18.5L13.3201 3Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconChartPyramid.js.map